import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/ONYX-Logo-White-Colour-X.svg'


const _hoisted_1 = {
  class: "collapse navbar-collapse",
  id: "navbarCollapse"
}
const _hoisted_2 = { class: "navbar-nav ms-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_burst_collector = _resolveComponent("burst-collector")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(`navbar navbar-expand-lg navbar-dark fixed-top ${$setup.path === 'Login' ? 'hide' : ''}`)
  }, [
    _createVNode(_component_router_link, {
      class: "navbar-brand",
      to: "/"
    }, {
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("img", {
          class: "logo",
          src: _imports_0,
          height: "45"
        }, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Blade Monitoring ", -1)),
        _createTextVNode(" - " + _toDisplayString(_ctx.siteName), 1)
      ]),
      _: 1
    }),
    _cache[6] || (_cache[6] = _createElementVNode("button", {
      class: "navbar-toggler",
      type: "button",
      "data-toggle": "collapse",
      "data-target": "#navbarCollapse",
      "aria-controls": "navbarCollapse",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation",
      "data-bs-target": "#navbarCollapse",
      "data-bs-toggle": "collapse"
    }, [
      _createElementVNode("span", { class: "navbar-toggler-icon" })
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        (!$setup.isExternalUser())
          ? (_openBlock(), _createBlock(_component_draggable, {
              key: 0,
              class: "collapse navbar-collapse",
              id: "navbarCollapse",
              modelValue: _ctx.selectedPages,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPages) = $event)),
              group: "people",
              onStart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drag = true)),
              onEnd: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drag = true)),
              "item-key": "order",
              disabled: !_ctx.editNavBar,
              onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.update_pages()))
            }, {
              item: _withCtx(({ element }) => [
                _withDirectives(_createElementVNode("li", {
                  class: _normalizeClass(`${!_ctx.editNavBar ? '' : 'editable'} navItem`)
                }, [
                  _createVNode(_component_router_link, {
                    class: "nav-link",
                    to: element.link
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(element.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ], 2), [
                  [_vShow, $setup.isPageVisible(element)]
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"]))
          : _createCommentVNode("", true),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: "/settings"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_vue_feather, { type: "settings" })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (!$setup.isExternalUser())
      ? (_openBlock(), _createBlock(_component_burst_collector, { key: 0 }))
      : _createCommentVNode("", true)
  ], 2))
}